import {
  ConfigProvider,
  Layout,
  Button,
  Card,
  Form,
  Input,
  Select,
  DatePicker,
  Menu,
  Tabs,
  Tooltip,
  Empty,
  Icon,
  Carousel
} from 'ant-design-vue'

const components = [
  ConfigProvider,
  Layout,
  Layout.Header,
  Layout.Content,
  Button,
  Card,
  Form,
  Form.Item,
  Input,
  Select,
  Select.Option,
  DatePicker,
  DatePicker.RangePicker,
  Menu,
  Menu.Item,
  Tabs,
  Tabs.TabPane,
  Tooltip,
  Empty,
  Icon,
  Carousel
]

export default {
  install(Vue, options) {
    components.map(cpn => {
      Vue.component(cpn.name, cpn)
    })
  }
}
